<div [ngStyle]="{ 'width.px': width }" class="timesheet__item">
  <timesheet-info [width]="width" [text]="location"></timesheet-info>
</div>
